import React from 'react';

const SPONSOR_PLANS = [
  {
    name: 'Поддержка стаи',
    price: '199 ₽/мес',
    features: [
      'Уникальный бейдж в профиле',
      'Приоритетная поддержка',
      'Доступ к эксклюзивным стикерам',
      'Подсветка имени в чате'
    ],
    color: 'from-blue-500 to-cyan-500',
    popular: false
  },
  {
    name: 'Хищник Sharkly',
    price: '499 ₽/мес',
    features: [
      'Всё из "Поддержка стаи"',
      'Золотой бейдж админа',
      'Ранний доступ к новым функциям',
      'Персональная тема профиля',
      'Без рекламы навсегда'
    ],
    color: 'from-yellow-500 to-orange-500',
    popular: true
  },
  {
    name: 'Легенда океана',
    price: '999 ₽/мес',
    features: [
      'Всё из "Хищник Sharkly"',
      'Платиновый статус',
      'Собственный клан (до 50 участников)',
      'Организация клановых битв',
      'Личный менеджер поддержки',
      'Имя в зале славы'
    ],
    color: 'from-purple-500 to-pink-500',
    popular: false
  },
];

// Текстовая иконка Steam - теперь 64x64px как у остальных
const SteamTextIcon = () => (
  <div className="flex items-center justify-center w-16 h-16 rounded-xl bg-[#66c0f4]/20 border border-[#66c0f4]/30 backdrop-blur-sm">
    <span className="text-[#66c0f4] font-black text-lg tracking-tighter uppercase">
      STEAM
    </span>
  </div>
);

// Обёртка для эмодзи - тоже 64x64px для единообразия
const EmojiIcon = ({ emoji }: { emoji: string }) => (
  <div className="flex items-center justify-center w-16 h-16 rounded-xl bg-white/10 border border-white/20 backdrop-blur-sm">
    <span className="text-4xl">{emoji}</span>
  </div>
);

const DONATION_OPTIONS = [
  {
    title: 'CS2 Скины',
    description: 'Трейды через Steam Trade URL',
    icon: <SteamTextIcon />,
    gradient: 'bg-gradient-to-br from-[#1b2838] to-[#0f1923]',
    accent: '#66c0f4',
    link: 'https://steamcommunity.com/tradeoffer/new/?partner=717054964&token=CbgnHZMQ',
    buttonText: 'Отправить трейд'
  },
  {
    title: 'Boosty',
    description: 'Ежемесячная подписка с бонусами',
    icon: <EmojiIcon emoji="🚀" />,
    gradient: 'bg-gradient-to-br from-[#f15f2c] to-[#d94e1f]',
    accent: '#ffffff',
    link: 'https://boosty.to/sharkly',
    buttonText: 'Поддержать на Boosty'
  },
  {
    title: 'DonationAlerts',
    description: 'Разовый донат с уведомлением',
    icon: <EmojiIcon emoji="💰" />,
    gradient: 'bg-gradient-to-br from-[#ffcc00] to-[#ffb700]',
    accent: '#000000',
    link: 'https://www.donationalerts.com/r/akylich_ilya',
    buttonText: 'Отправить донат'
  },
];

const SponsorshipPage: React.FC = () => {
  return (
    <div className="max-w-6xl mx-auto p-6 pb-24 md:pb-6">
      {/* Заголовок */}
      <div className="text-center mb-16 relative">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-64 h-64 bg-blue-500/20 rounded-full blur-[100px] -z-10"></div>
        <h1 className="text-4xl md:text-6xl font-black text-white mb-4 flex items-center justify-center gap-3 tracking-tight">
          💎 Поддержи Sharkly
        </h1>
        <p className="text-gray-400 text-lg max-w-2xl mx-auto leading-relaxed">
          Выбери удобный способ поддержки проекта. Каждый донат помогает нам развиваться и создавать новые функции!
        </p>
      </div>

      {/* Баннеры донатов - Glassmorphism Style */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-20 px-2">
        {DONATION_OPTIONS.map((option, i) => (
          <a
            key={i}
            href={option.link}
            target="_blank"
            rel="noopener noreferrer"
            className="group relative block rounded-3xl transition-all duration-500 hover:-translate-y-2 hover:scale-[1.02]"
            style={{
              boxShadow: `0 20px 40px -10px ${option.accent}40`,
              border: `1px solid ${option.accent}30`
            }}
          >
            {/* Фон с градиентом и размытием */}
            <div className={`absolute inset-0 ${option.gradient} opacity-90 group-hover:opacity-100 transition-opacity rounded-3xl`} />

            {/* Эффект стекла */}
            <div className="absolute inset-0 backdrop-blur-xl rounded-3xl bg-white/5 group-hover:bg-white/10 transition-colors" />

            {/* Декоративные элементы */}
            <div className="absolute top-0 right-0 w-32 h-32 bg-white/5 rounded-full blur-2xl -mr-10 -mt-10 pointer-events-none"></div>
            <div className="absolute bottom-0 left-0 w-24 h-24 bg-black/20 rounded-full blur-xl -ml-5 -mb-5 pointer-events-none"></div>

            {/* Контент */}
            <div className="relative p-8 h-full flex flex-col justify-between min-h-[320px] z-10">
              <div>
                <div className="flex items-start justify-between mb-6">
                  <div className="transform group-hover:scale-110 transition-transform duration-300 origin-bottom-left drop-shadow-lg">
                    {option.icon}
                  </div>
                  <div
                    className="w-10 h-10 rounded-full flex items-center justify-center border border-white/20 bg-white/10 backdrop-blur-md group-hover:bg-white/20 transition-colors"
                    style={{ color: option.accent }}
                  >
                    ↗
                  </div>
                </div>

                <h3
                  className="text-3xl font-black mb-3 tracking-tight"
                  style={{ color: option.accent }}
                >
                  {option.title}
                </h3>
                <p className="text-white/70 text-sm font-medium leading-relaxed">
                  {option.description}
                </p>
              </div>

              <div className="mt-8 pt-6 border-t border-white/10">
                <button
                  className="w-full py-3.5 rounded-xl font-bold text-sm uppercase tracking-wider transition-all duration-300 group-hover:shadow-lg flex items-center justify-center gap-2"
                  style={{
                    backgroundColor: `${option.accent}20`,
                    color: option.accent,
                    border: `1px solid ${option.accent}40`
                  }}
                >
                  {option.buttonText}
                  <span className="transform group-hover:translate-x-1 transition-transform">→</span>
                </button>
              </div>
            </div>
          </a>
        ))}
      </div>

      {/* Разделитель */}
      <div className="flex items-center gap-6 mb-16 px-4">
        <div className="flex-1 h-px bg-gradient-to-r from-transparent via-gray-700 to-transparent"></div>
        <span className="text-gray-500 text-xs font-bold uppercase tracking-[0.2em] whitespace-nowrap">Или оформи подписку</span>
        <div className="flex-1 h-px bg-gradient-to-r from-transparent via-gray-700 to-transparent"></div>
      </div>

      {/* Тарифы подписки */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-20">
        {SPONSOR_PLANS.map((plan, i) => (
          <div
            key={i}
            className={`relative bg-[#1a1d24] rounded-3xl border overflow-hidden transition-all duration-300 hover:-translate-y-2 ${
              plan.popular 
                ? 'border-yellow-500/50 shadow-[0_0_40px_rgba(234,179,8,0.15)] scale-105 z-10' 
                : 'border-gray-800 hover:border-gray-600 hover:shadow-xl'
            }`}
          >
            {plan.popular && (
              <div className="absolute top-0 left-0 right-0 bg-gradient-to-r from-yellow-500 to-orange-500 text-black text-center py-2 text-xs font-black uppercase tracking-widest">
                 Популярный выбор
              </div>
            )}

            <div className={`p-8 ${plan.popular ? 'pt-14' : ''}`}>
              <h3 className="text-2xl font-black text-white mb-2">{plan.name}</h3>
              <div className="text-4xl font-black text-white mb-8">
                {plan.price}
              </div>

              <ul className="space-y-4 mb-8">
                {plan.features.map((feature, j) => (
                  <li key={j} className="flex items-start gap-3 text-gray-300 text-sm font-medium">
                    <span className="text-green-400 mt-0.5 shrink-0">✓</span>
                    {feature}
                  </li>
                ))}
              </ul>

              <button className={`w-full py-3.5 rounded-xl font-bold transition-all ${
                plan.popular
                  ? 'bg-gradient-to-r from-yellow-500 to-orange-500 hover:from-yellow-400 hover:to-orange-400 text-black shadow-[0_0_20px_rgba(234,179,8,0.4)] hover:shadow-[0_0_30px_rgba(234,179,8,0.6)]'
                  : 'bg-gray-800 hover:bg-gray-700 text-white border border-gray-700 hover:border-gray-500'
              }`}>
                Выбрать план
              </button>
            </div>
          </div>
        ))}
      </div>

      {/* FAQ */}
      <div className="bg-[#1a1d24]/50 backdrop-blur-sm rounded-3xl border border-gray-800/50 p-8 md:p-12">
        <h2 className="text-2xl font-bold text-white mb-8 flex items-center gap-3"> Частые вопросы</h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <div className="space-y-6">
            <div>
              <h3 className="text-lg font-bold text-white mb-2">Как отправить скины через Steam?</h3>
              <p className="text-gray-400 text-sm leading-relaxed">Нажми на баннер "CS2 Скины", перейдёшь в Steam. Нажми "Предложить обмен", выбери скины и отправь. Мы подтвердим обмен в течение часа.</p>
            </div>

            <div>
              <h3 className="text-lg font-bold text-white mb-2">Что даёт подписка?</h3>
              <p className="text-gray-400 text-sm leading-relaxed">Подписчики получают уникальные бейджи, ранний доступ к функциям, эксклюзивные стикеры и многое другое. Подробности в тарифах выше.</p>
            </div>
          </div>

          <div className="space-y-6">
            <div>
              <h3 className="text-lg font-bold text-white mb-2">Можно ли комбинировать способы?</h3>
              <p className="text-gray-400 text-sm leading-relaxed">Да! Ты можешь одновременно поддерживать через скины, Boosty и DonationAlerts. Все привилегии суммируются.</p>
            </div>

            <div>
              <h3 className="text-lg font-bold text-white mb-2">Куда идут деньги?</h3>
              <p className="text-gray-400 text-sm leading-relaxed">Все средства направляются на развитие платформы: улучшение серверов, создание нового контента, оплата хостинга и поддержку команды разработчиков.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SponsorshipPage;
